import type {AccountTypeId} from '../types';

export type AccountType = {
    id: AccountTypeId;
    type: 'accountTypes';
    name: string;
    modifiedTime: number | null | undefined; // UNIX secs;
};
